import {
  Container,
  Grid,
  makeStyles,
  Paper,
  Typography,
  useMediaQuery,
  useTheme
} from '@material-ui/core';
import { Form, Formik } from 'formik';
import { withSnackbar } from 'notistack';
import React, { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useRouteMatch } from 'react-router-dom/cjs/react-router-dom';
import AutocompleteWithFormik from '../../../../components/inputs/AutocompleteWithFormik';
import InputWithFormik from '../../../../components/inputs/InputWithFormik';
import FinalButtons from '../../../../FinalButtons';
import FinalButtonsMobile from '../../../../FinalButtonsMobile';
import PaisService from '../../../../services/PaisService';
import axios from '../../../../utils/axios';

import { Yup } from '../../../../utils/form-utils';
import FormikSubmitEffect from '../FormikSubmitEffect';

const useStyles = makeStyles(theme => ({
  container: {
    marginLeft: 0,
    marginRight: 0,
    paddingBottom: theme.spacing(8),
    [theme.breakpoints.down('sm')]: {
      paddingBottom: 0,
      padding: 0
    }
  },
  innerContainer: {
    [theme.breakpoints.down('sm')]: {
      padding: 0
    }
  },
  paper: {
    // marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    padding: theme.spacing(4),
    // marginLeft: theme.spacing(6),
    // marginRight: theme.spacing(6),
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      marginBottom: 0,
      padding: theme.spacing(0),
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(5)
    }
  },
  inputGroup: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2)
  }
}));

const validEmailAddress = 'validation.validEmailAddress';
const validationSchema = Yup.object().shape({
  nombre: Yup.string().required(),
  direccion: Yup.string().required(),
  email: Yup.string()
    .email(validEmailAddress)
    .required(),
  telefono: Yup.string().required(),
  pais: Yup.object().shape({
    valor: Yup.string().required()
  }),
  ciudad: Yup.string().required(),
  codigoPostal: Yup.number()
    .typeError('Solo se permiten números')
    .required()
});

const ImportadorEditForm = props => {
  const { enqueueSnackbar } = props;
  const {
    params: { id }
  } = useRouteMatch();
  // const { paises } = useContext(FormContext);
  const [paises, setPaises] = useState([]);
  const formik = useRef();
  const classes = useStyles();
  const [loadingSendPre, setLoadingSendPre] = useState(false);
  const history = useHistory();
  const myRef = useRef(null);
  const theme = useTheme();
  const isPhone = useMediaQuery(theme.breakpoints.down('sm'));
  const [baseObject, setBaseObject] = useState({
    nombre: '',
    email: '',
    telefono: '',
    direccion: '',
    pais: '',
    ciudad: '',
    codigoPostal: ''
  });
  // const configuraciones = formulariosConfig({
  //   classes: {}
  // });
  // const dataset = 'formularios';
  const gridProps = {
    spacing: 3,
    className: classes.inputGroup
  };

  const onSubmitError = () => {
    enqueueSnackbar('Verificar formatos y campos obligatorios', {
      variant: 'warning'
    });
  };

  const enviar = async () => {
    const { values } = formik.current;
    setLoadingSendPre(true);
    try {
      const valuesToSend = Object.assign({}, values);
      valuesToSend.pais = {
        id: values.pais.valor
      };
      try {
        const metodo = id ? 'actualizar' : 'crear';
        await axios.post(`importador/${metodo}`, valuesToSend);
        enqueueSnackbar('Guardado correctamente', { variant: 'success' });
        history.push('/importadores');
      } catch (err) {
        console.log('err', err);
        enqueueSnackbar(
          err?.response?.data?.message || 'Error al intentar guardar',
          {
            variant: 'error'
          }
        );
      }

      setLoadingSendPre(false);
    } catch (error) {
      setLoadingSendPre(false);
    }
  };

  const onSubmit = () => {
    enviar();
  };

  const handleBack = () => {
    history.push('/importadores');
  };

  const buttonProps = {
    okText: id ? 'Actualizar' : 'Guardar',
    cancelText: 'Volver',
    handleBack,
    isPhone,
    classes,
    loadingSendPre
  };

  const Buttons = () =>
    isPhone ? (
      <FinalButtonsMobile {...buttonProps} />
    ) : (
      <FinalButtons {...buttonProps} />
    );

  const loadData = async idParam => {
    const response = await axios.get(`importador/${idParam}`);
    const nuevosDatos = { ...response.data };
    nuevosDatos.pais = {
      texto: nuevosDatos.pais.nombre,
      valor: nuevosDatos.pais.id
    };
    setBaseObject(prev => ({ ...prev, ...nuevosDatos }));
  };

  const loadPaises = () => {
    PaisService.getAll().then(response => {
      setPaises(
        response.data.data
          .map(item => ({
            texto: item.nombre,
            valor: item.id
          }))
          .sort((a, b) => (a.texto > b.texto ? 1 : -1))
      );
    });
  };

  useEffect(
    () => {
      loadData(id);
      loadPaises();
    },
    [id]
  );

  return (
    <div>
      <div className={classes.container}>
        <Paper className={classes.paper} elevation={8}>
          <div ref={myRef} style={{ height: 16 }} />
          <Container maxWidth="md" style={{ marginLeft: 0 }}>
            <div style={{ paddingBottom: 40 }}>
              <Grid container item>
                <Typography variant="h6" gutterBottom>
                  Formulario de carga de Importador
                </Typography>
              </Grid>

              <Formik
                enableReinitialize
                initialValues={baseObject}
                validationSchema={validationSchema}
                innerRef={formik}
                onSubmit={onSubmit}
              >
                {() => (
                  <>
                    <FormikSubmitEffect
                      onSubmitError={onSubmitError}
                      validationSchema={validationSchema}
                    />
                    <Form noValidate>
                      <Grid container {...gridProps}>
                        <Grid item xs={12} md={12}>
                          <InputWithFormik
                            label="Razón Social"
                            name="nombre"
                            required
                          />
                        </Grid>
                        <Grid container item>
                          <Typography
                            variant="subtitle2"
                            color="textSecondary"
                            gutterBottom
                          >
                            Datos de contacto
                          </Typography>
                        </Grid>
                        <Grid item xs={12} md={12}>
                          <InputWithFormik
                            label="Nombre"
                            name="personaContacto"
                            required
                          />
                        </Grid>
                        <Grid item xs={12} md={12}>
                          <InputWithFormik
                            label="Apellido"
                            name="personaContactoApellido"
                            required
                          />
                        </Grid>
                        <Grid item xs={12} md={8}>
                          <InputWithFormik
                            label="Correo electrónico"
                            name="email"
                            required
                          />
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <InputWithFormik
                            label="Teléfono / Fax"
                            name="telefono"
                            required
                          />
                        </Grid>
                        <Grid container item>
                          <Typography
                            variant="subtitle2"
                            color="textSecondary"
                            gutterBottom
                          >
                            Datos de ubicación
                          </Typography>
                        </Grid>
                        <Grid item xs={12} md={12}>
                          <InputWithFormik
                            label="Dirección"
                            name="direccion"
                            required
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <AutocompleteWithFormik
                            required
                            label="País"
                            name="pais"
                            options={paises}
                            labelKey="texto"
                            valueKey="valor"
                            isObjectValue
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <InputWithFormik
                            label="Ciudad"
                            name="ciudad"
                            required
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <InputWithFormik
                            label="Código postal"
                            name="codigoPostal"
                            required
                          />
                        </Grid>
                      </Grid>
                      <Buttons />
                    </Form>
                  </>
                )}
              </Formik>
            </div>
          </Container>
        </Paper>
      </div>
    </div>
  );
};

export default withSnackbar(ImportadorEditForm);
